type BitwiseCb = (pos: number) => number;

const getBitmap =
  (cb: BitwiseCb) =>
  (bitmap: number): number[] =>
    bitmap
      .toString(2)
      .split('')
      .toReversed()
      .map(Number)
      .reduce<number[]>((arr, val, pos) => {
        if (val) {
          return [...arr, cb(pos)];
        }
        return arr;
      }, []);

/**
 * Converts a given binary number to an array of indices.
 *
 * @param bitmap - Binary value to convert
 * @returns An array of the set bit positions indices
 */
export const bitmapToPositions = getBitmap((pos) => pos);

/**
 * Converts a given binary number to an array of the bit values.
 *
 * @param bitmap - Binary value to convert
 * @returns An array of binary representations
 */
export const bitmapToArray = getBitmap((pos) => 2 ** pos);

/**
 * Converts a string of 1, X, and 2 characters to a binary number.
 *
 * @param input - The input string to convert.
 * @returns The binary representation of the input string.
 */
export function oneXTwoToBinary(input: string): number {
  const lookup = ['1', 'X', '2'];
  const binary = input.split('').reduce((acc, v) => acc + 2 ** lookup.indexOf(v), 0);

  return binary;
}
